import {
  type DealItemWithVersions,
  PricingMode,
} from '@/lib/graphql/generated/graphql';

export function getProductsMissingMargin(
  products: DealItemWithVersions[],
  pricingMode: PricingMode
): DealItemWithVersions[] {
  if (pricingMode !== PricingMode.MarginFixed) return [];

  return products.filter(
    ({ activeVersion }) => activeVersion.marginPercentage == null
  );
}
